module.exports = __webpack_public_path__ + "img/3f.749dc4b7.png";